import { useEffect } from 'react';
import { Box, Tab, Typography } from '@mui/material';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import { useLocation, useNavigate } from 'react-router-dom';
import { Styled } from './settings-workspace.styled';
import { SettingsTab } from './props';
import useBreakpoint from '../../../hooks/use-breakpoint';

const SettingsNavigation = ({ tabs }: { tabs: SettingsTab[] }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { biggerThan } = useBreakpoint();

    const stepKey: string | undefined = location.pathname.split('/').at(-1);

    useEffect(() => {
        if (!tabs.some((tab) => tab.url === stepKey)) {
            navigate(tabs[0]?.url);
        }
    }, [stepKey, tabs, navigate]);

    return (
        <Styled.Navigation>
            <Styled.NavigationTabs
                variant={biggerThan('sm') ? 'standard' : 'scrollable'}
                scrollButtons="auto"
                orientation={biggerThan('sm') ? 'vertical' : 'horizontal'}
                value={stepKey}
            >
                {tabs.map((tab) => {
                    if (tab.disabled) return null;

                    return (
                        <Tab
                            key={tab.url}
                            value={tab.url}
                            onClick={() => navigate(tab.url)}
                            icon={tab.icon}
                            iconPosition="start"
                            label={
                                <Box className="settings-tab-label">
                                    <Typography component="span">
                                        {tab.label}
                                    </Typography>
                                    <ChevronLeftRoundedIcon className="settings-tab-arrow" />
                                </Box>
                            }
                        />
                    );
                })}
            </Styled.NavigationTabs>
        </Styled.Navigation>
    );
};

export { SettingsNavigation };
